const config = [{ propName: 'notes', reducerName: 'notes' }];

export const getAtsInterviews = (state) => {
  const atsInterviews = {};

  config.forEach(({ propName, reducerName }) => {
    atsInterviews[propName] = state?.atsInterviews?.[reducerName];
  });

  return atsInterviews;
};
